module.exports = __webpack_public_path__ + "img/game_sign_introduce.21ba59a2.png";